import { getCookieValue, setCookie } from '@/core/utils/cookies.client';
import { createId } from '@/core/utils/string';
import { SESSION_ID } from './cookies.config';

export function getSessionCookie(): Promise<string | null> {
	return getCookieValue(SESSION_ID);
}

async function setSessionCookie(value: string): Promise<void> {
	await setCookie(SESSION_ID, value);
}

export async function getOrCreateSessionIdCookie(): Promise<string> {
	const existing = await getSessionCookie();

	if (existing) return existing;

	const value = createId();
	await setSessionCookie(value);

	return value;
}

export async function refreshOrCreateSessionCookie(): Promise<string> {
	const value = (await getSessionCookie()) ?? createId();
	await setSessionCookie(value);

	return value;
}
